import { useNavigate } from "react-router-dom";
import "../css/NotFound.css";
/**
 * This component is displayed when a requested route or page is not found in the application.
 *
 * @returns {JSX.Element} The rendered NotFound component.
 */
const NotFound = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate("/");
  };

  return (
    <div className="NotFound">
      <h1 className="not-found-title">404</h1>
      <p className="not-found-text">
        the requested url was not found on this server
      </p>
      <button className="back-to-home-btn" onClick={handleBackToHome}>
        back to home
      </button>
    </div>
  );
};

export default NotFound;
